import styled from 'styled-components';
import { color } from '~/assets/styles/colors';

export const Card = styled.div`
	width: 100%;
	height: 100%;
	background-color: ${color.white};
	background-color: ${(props) => props.bgcolor === 'red' && color.red};
	background-color: ${(props) => props.bgcolor === 'green' && color.green};
	background-color: ${(props) => props.bgcolor === 'purple' && color.purple};
	background-color: ${(props) => props.bgcolor === 'blue' && color.blueLight};
	background-color: ${(props) => props.bgcolor === 'orange' && color.orange};
	background-color: ${(props) => props.bgcolor === 'yellow' && color.yellow};
	background-color: ${(props) => props.bgcolor === 'gray' && color.gray};
	background-color: ${({ bgcolor }) =>
		bgcolor === 'softBlack' && color.softBlack};
`;

export const Symbol = styled.span`
	font-weight: 600;
	font-size: 12px;
	margin-right: 5px;
`;

export const Price = styled.span`
	font-weight: 400;
	font-size: 36px;
`;

export const Tag = styled.div`
	width: 45px;
	height: 20px;
	line-height: 20px;
	font-size: 12px;
	text-align: center;

	position: absolute;
	right: 0;
	bottom: 10px;
	background-color: ${color.white};

	font-weight: 600;
	color: ${(props) => props.textColor === 'red' && color.red};
	color: ${(props) => props.textColor === 'green' && color.green};
`;
